import axios, { type CreateAxiosDefaults } from "axios";
import { EnvVariables, isDevelopment } from "@/env-variables";
import { requestInterceptor, responseInterceptor } from "./axios-interceptor";

interface AxiosInstanceOptions {
  withCredentials?: boolean;
  baseURL?: string;
  timeout?: number;
}

export const createNewAxiosInstance = (
  config: CreateAxiosDefaults = {},
  options?: AxiosInstanceOptions,
) => {
  const headers = { "Content-Type": "application/json" };
  const timeout = options?.timeout || 60000;

  // Since we removed Nginx reverse proxy, we MUST use absolute API URL in Production/Staging.
  // However, in Development (localhost), we must use Vite Proxy to avoid CORS errors.
  // - Development: baseURL = undefined (relative path) -> Vite Proxy handles it
  // - Production/Staging: baseURL = EnvVariables.apiUrl (absolute path)
  const defaultBaseURL = isDevelopment() ? undefined : EnvVariables.apiUrl;
  const baseURL = options?.baseURL || defaultBaseURL;
  const withCredentials = options?.withCredentials || false;

  const instance = axios.create({
    baseURL,
    headers,
    timeout,
    withCredentials,
    ...config,
  });

  instance.interceptors.response.use(
    responseInterceptor.onFulfilled,
    responseInterceptor.onRejected,
  );
  instance.interceptors.request.use(requestInterceptor.onFulfilled, requestInterceptor.onRejected);
  return instance;
};

export const axiosInstance = createNewAxiosInstance();
